import {
  SYSTEM_AREA_MODAL_CHANGE,
} from './constants';

export function areaModalChange(visible,type) {
  return {
    type: SYSTEM_AREA_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_AREA_MODAL_CHANGE:
      return {
        ...state,
        areaModalType:action.data.type,
        areaModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/areaModalChange.js